import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { submitApplication } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { SubmitApplicationPayload, SubmitApplicationResponse } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

interface SubmitApplicationParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: SubmitApplicationPayload;
}

export const useSubmitApplication = (
  options?: UseMutationOptions<SubmitApplicationResponse, Error, SubmitApplicationParams>
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation<SubmitApplicationResponse, Error, SubmitApplicationParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      submitApplication(userId, applicationId, providerType, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: providerOnboardingQueryKeys.all });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
